import "./style.css";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";

import Avaliacao from "../../images/feedback/avaliacao.png";
import fb1 from "../../images/feedback/1.png";
import fb2 from "../../images/feedback/2.png";
import fb3 from "../../images/feedback/3.png";

export default function Feedback() {
  return (
    <div className="feedback-container" id="Feedback">
      <div className="feedback-title-container">
        <h3 className="feedback-subtitle">Não ouça apenas nós</h3>
        <h2 className="feedback-title">O que nossos clientes dizem?</h2>
      </div>
      <div className="feedback-slider">
        <Swiper
          slidesPerView={1}
          spaceBetween={30}
          loop={true}
          pagination={{
            clickable: true,
          }}
          navigation={true}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          modules={[Pagination, Navigation, Autoplay]}
          className="mySwiper"
        >
          <SwiperSlide>
            <img src={fb1} alt="Avaliacao 1" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={fb2} alt="Avaliacao 2" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={fb3} alt="Avaliacao 3" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={fb1} alt="Avaliacao 1" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={fb2} alt="Avaliacao 2" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={fb3} alt="Avaliacao 3" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={fb1} alt="Avaliacao 1" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={fb2} alt="Avaliacao 2" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={fb3} alt="Avaliacao 3" />
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
}